module.exports = __webpack_public_path__ + "static/media/zerply.c861e6e6.png";